import React from "react"
import { graphql, StaticQuery, Link } from "gatsby"
import Post from "./post"
import { Button } from "react-bootstrap"
export default function ConcertCat() {
  return (
    <div className="concert-cat-blog">
      <div>
        <div className="title">
          <span className="badge">کنسرت‌ها</span>
        </div>
        <Link to="/concertpage">
          <Button variant="outline-secondary" className="show-all-btn">
            تمام کنسرت‌ها
          </Button>
        </Link>
      </div>
      <div className="cats-posts" id="cats-posts-scroll">
        <StaticQuery
          query={blogquery}
          render={data => {
            return (
              <div>
                {data.allMarkdownRemark.edges.map(({ node }) => (
                  <section className="posts">
                    <Post
                      key={node.id}
                      title={node.frontmatter.title}
                      date={node.frontmatter.date}
                      slug={node.fields.slug}
                      body={node.excerpt}
                      fluid={node.frontmatter.image.childImageSharp.fluid}
                    />
                  </section>
                ))}
              </div>
            )
          }}
        />
      </div>
    </div>
  )
}

const blogquery = graphql`
  query {
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      limit: 10
      filter: { frontmatter: { cat: { eq: "concert" } } }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            date
            image {
              childImageSharp {
                fluid(maxWidth: 600) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            cat
          }
          excerpt(truncate: true)
          fields {
            slug
          }
        }
      }
    }
  }
`
